<nav role="menu">
  <div class="searchContainer" [class.hideSearch]="navServ.current()">
    <div>
      <form>
        <input class="searchBox" type="text" aria-label="Search" [formField]="searchForm.term" />&nbsp;<button class="searchBtn" (click)="submit()"><img src="search.svg" alt="Search"/></button>
      </form>
    </div>
    <div class="toggleSortBar">
      <button (click)="toggleSort()">
        <img class="sortIcon" src="sort-alpha-asc.svg" alt="Sort alphabetically"/>&nbsp;
        <img class="sortIcon" [src]="sortChrono ? 'toggle-on.svg' : 'toggle-off.svg'" alt="Change sort"/>&nbsp;
        <img class="sortIcon" src="sort-numeric-asc.svg" alt="Sort Chronologically"/>
      </button>
    </div>
  </div>
  <div class="century" [class.hideMenu]="navServ.current()">
  @for (key of getNavKeys(); track $index) {
    <div aria-label="{{key}} menu item" (click)="setKey(key)" [class.active]="navServ.expand() === key" [innerHTML]="key"></div>
  }
  </div>
  <div class="container" [class.hideMenu]="navServ.current()">
  @for (key of getNavKeys(); track $index) {
    @for(item of getNavItems(key); track $index) {
      <div role="menuitem" aria-label="{{item.aria}}" [class.hideMenu]="navServ.expand() !== key" [class.activeKey]="navServ.expand() === key"><a role="link" [routerLink]="[item.path]">{{item.show}}</a></div>
    }
  }
  </div>
  <button class="toggle-menu" (click)="menuclick()" aria-label="Menu"><img class="menuimg" src="bars.svg" alt="Expand and Collapse Menu"/></button>
</nav>